/* eslint-disable prettier/prettier */
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../redux/configureStore';
import Wrapper from '../../../../../../../../shared/components/Wrapper';
import convertToRealWithChecked, {
  convertToReal,
} from '../../../../../../../../utils/values';
import { AccountingDivisorDarken } from '../../../AccountingDivisor';
import Text from '../Text';

function UnifiedReportOfFiduciaClosed() {
  const accountingAppContext = useSelector(
    (reducer: IReducer) => reducer.closedData
  );

  return (
    <Wrapper.Default isActive margin="auto" flexDirection="column" width="100%">
      <Text.Title>
        Relatório de Fechamento de{' '}
        {moment(accountingAppContext.dateSearch.start).format('DD/MM/YY')} até{' '}
        {moment(accountingAppContext.dateSearch.end).format('DD/MM/YY')}
      </Text.Title>

      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TRANSFERÊNCIAS</Text.LabelC>
        <Text.LabelC>Recebimento de TED</Text.LabelC>
        <Text.LabelC>STR0008R2</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_transferencia_externa.STR0008R2
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TRANSFERÊNCIAS</Text.LabelC>
        <Text.LabelC>Estorno de TED</Text.LabelC>
        <Text.LabelC>STR0010R2</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_transferencia_externa.STR0010R2
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TRANSFERÊNCIAS</Text.LabelC>
        <Text.LabelC>Recebimento de IF para IF</Text.LabelC>
        <Text.LabelC>STR0006R2</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_transferencia_externa.STR0006R2
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TRANSFERÊNCIAS</Text.LabelC>
        <Text.LabelC>Recebimento de TED</Text.LabelC>
        <Text.LabelC>STR0007R2</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_transferencia_externa.STR0007R2
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TRANSFERÊNCIAS</Text.LabelC>
        <Text.LabelC>Pix</Text.LabelC>
        <Text.LabelC>Pix</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_transferencia_externa.Pix
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TRANSFERÊNCIAS</Text.LabelC>
        <Text.LabelC>Pix devolução</Text.LabelC>
        <Text.LabelC>Pix_devolucao</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_transferencia_externa
                .Pix_Devolucao
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TRANSFERÊNCIAS</Text.LabelC>
        <Text.LabelC>Recebimento de transferência de outra IF</Text.LabelC>
        <Text.LabelC>STR0004R2 (FIDÚCIA INVEST)</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_transferencia_externa
                .STR0004R2_INVEST
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TRANSFERÊNCIAS</Text.LabelC>
        <Text.LabelC>Recebimento de transferência de outra IF</Text.LabelC>
        <Text.LabelC>STR0004R2_FGTS</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_transferencia_externa
                .STR0004R2_FGTS
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>ENVIO DE TRANSFERÊNCIA EXTERNAS</Text.LabelC>
        <Text.LabelC>Pix</Text.LabelC>
        <Text.LabelC>Pix</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.envio_transferencia_externa.Pix
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>ENVIO DE TRANSFERÊNCIA EXTERNAS</Text.LabelC>
        <Text.LabelC>Pix Devolução</Text.LabelC>
        <Text.LabelC>Pix_Devolucao</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.envio_transferencia_externa.Pix_Devolucao
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE DOMICÍLIO BANCÁRIO</Text.LabelC>
        <Text.LabelC>Fluxo de Crédito - CIP</Text.LabelC>
        <Text.LabelC>ASLC022</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_domicilio_bancario.ASLC022
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE DOMICÍLIO BANCÁRIO</Text.LabelC>
        <Text.LabelC>Fluxo de Crédito - CIP</Text.LabelC>
        <Text.LabelC>ASLC022</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_domicilio_bancario.ASLC022
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE DOMICÍLIO BANCÁRIO</Text.LabelC>
        <Text.LabelC>Fluxo de Débito - CIP</Text.LabelC>
        <Text.LabelC>ASLC032</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_domicilio_bancario.ASLC032
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE DOMICÍLIO BANCÁRIO</Text.LabelC>
        <Text.LabelC>Fluxo de Antecipação - CIP</Text.LabelC>
        <Text.LabelC>ASLC024</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_domicilio_bancario.ASLC024
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>ENVIO DE TRANSFERÊNCIAS INTERNAS</Text.LabelC>
        <Text.LabelC>TEV Interna</Text.LabelC>
        <Text.LabelC>STR0008</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.envio_transferencia_interna.STR0008
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>
          ENVIO DE TRANSFERÊNCIAS INTERNAS PARA CONTAS DE TERCEIROS
        </Text.LabelC>
        <Text.LabelC>TEV Interna</Text.LabelC>
        <Text.LabelC>STR0008</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.envio_transferencia_interna_conta_terceiros
                .STR0008
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>
          ENVIO DE TRANSFERÊNCIAS INTERNAS PARA CONTAS FIDÚCIA
        </Text.LabelC>
        <Text.LabelC>TEV Interna</Text.LabelC>
        <Text.LabelC>STR0008</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext
                .recebimento_transferencia_interna_conta_fiducia.STR0008
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TARIFA</Text.LabelC>
        <Text.LabelC>Tarifa de Pix</Text.LabelC>
        <Text.LabelC>TARIFA_PIX</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_tarifas.TARIFA_PIX
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>

      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TARIFA</Text.LabelC>
        <Text.LabelC>Tarifa de TEV</Text.LabelC>
        <Text.LabelC>TARIFA_RECEBIMENTO_TEV</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_tarifas.TARIFA_RECEBIMENTO_TEV
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TARIFA</Text.LabelC>
        <Text.LabelC>Tarifa de Recimento de TED</Text.LabelC>
        <Text.LabelC>TARIFA_RECEBIMENTO_TED</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_tarifas.TARIFA_RECEBIMENTO_TED
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TARIFA</Text.LabelC>
        <Text.LabelC>Tarifa de Recimento de Boleto</Text.LabelC>
        <Text.LabelC>TARIFA_RECEBIMENTO_BOLETO</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_tarifas.TARIFA_RECEBIMENTO_BOLETO
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TARIFA</Text.LabelC>
        <Text.LabelC>Tarifa de Recimento de domicilio bancário</Text.LabelC>
        <Text.LabelC>TARIFA_RECEBIMENTO_DOMICILIO</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_tarifas
                .TARIFA_RECEBIMENTO_DOMICILIO
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TARIFA</Text.LabelC>
        <Text.LabelC>Tarifa de Recimento de boleto liquidado</Text.LabelC>
        <Text.LabelC>TARIFA_BOLETO</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_tarifas.TARIFA_BOLETO
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TARIFA</Text.LabelC>
        <Text.LabelC>Tarifa Genérica</Text.LabelC>
        <Text.LabelC>TARIFA</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_tarifas.TARIFA
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TARIFA</Text.LabelC>
        <Text.LabelC>Tarifa de boleto vencido</Text.LabelC>
        <Text.LabelC>TARIFA_BOLETO_VENCIDO</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_tarifas.TARIFA_BOLETO_VENCIDO
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TARIFA</Text.LabelC>
        <Text.LabelC>Tarifa de mensalidade</Text.LabelC>
        <Text.LabelC>TARIFA_MENSAL</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_tarifas.TARIFA_MENSAL
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TARIFA</Text.LabelC>
        <Text.LabelC>Tarifa de alteração de boleto</Text.LabelC>
        <Text.LabelC>TARIFA_ALTERACAO_BOLETO</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_tarifas.TARIFA_ALTERACAO_BOLETO
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TARIFA</Text.LabelC>
        <Text.LabelC>Tarifa de boleto baixado</Text.LabelC>
        <Text.LabelC>TARIFA_BAIXADO</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_tarifas.TARIFA_BAIXADO
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TARIFA</Text.LabelC>
        <Text.LabelC>Tarifa de abertura de conta PJ</Text.LabelC>
        <Text.LabelC>TARIFA_ABERTURA_CONTA_PJ</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_tarifas.TARIFA_ABERTURA_CONTA_PJ
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TARIFA</Text.LabelC>
        <Text.LabelC>Tarifa de abertura de conta PF</Text.LabelC>
        <Text.LabelC>TARIFA_ABERTURA_CONTA_PF</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_tarifas.TARIFA_ABERTURA_CONTA_PF
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TARIFA</Text.LabelC>
        <Text.LabelC>Tarifa de abertura de conta escrow</Text.LabelC>
        <Text.LabelC>TARIFA_ABERTURA_CONTA_ESCROW</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_tarifas
                .TARIFA_ABERTURA_CONTA_ESCROW
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TARIFA</Text.LabelC>
        <Text.LabelC>Tarifa de abertura de conta Consignada</Text.LabelC>
        <Text.LabelC>TARIFA_ABERTURA_CONTA_CONSIGNADA</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_tarifas
                .TARIFA_ABERTURA_CONTA_CONSIGNADA
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa de TED</Text.LabelC>
        <Text.LabelC>TAXA_TED</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas.TAXA_TED
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Recebimento de transferência para outra IF</Text.LabelC>
        <Text.LabelC>STR0004</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas.STR0004
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa de Pix</Text.LabelC>
        <Text.LabelC>TARIFA_PIX</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas.TARIFA_PIX
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa genérica</Text.LabelC>
        <Text.LabelC>TARIFA</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas.TARIFA
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa de boleto vencido</Text.LabelC>
        <Text.LabelC>TARIFA_BOLETO_VENCIDO</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas.TARIFA_BOLETO_VENCIDO
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa de mensalidade</Text.LabelC>
        <Text.LabelC>TARIFA_MENSAL</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas.TARIFA_MENSAL
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa de alteração de boleto</Text.LabelC>
        <Text.LabelC>TARIFA_ALTERACAO_BOLETO</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas.TARIFA_ALTERACAO_BOLETO
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa de boleto baixado</Text.LabelC>
        <Text.LabelC>TARIFA_BAIXADO</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas.TARIFA_BAIXADO
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa de abertura de conta PF</Text.LabelC>
        <Text.LabelC>TARIFA_ABERTURA_CONTA_PF</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas.TARIFA_ABERTURA_CONTA_PF
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa de abertura de conta PJ</Text.LabelC>
        <Text.LabelC>TARIFA_ABERTURA_CONTA_PJ</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas.TARIFA_ABERTURA_CONTA_PJ
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa de abertura de conta escrow</Text.LabelC>
        <Text.LabelC>TARIFA_ABERTURA_CONTA_ESCROW</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas.TARIFA_ABERTURA_CONTA_ESCROW
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa de abertura de conta consignada</Text.LabelC>
        <Text.LabelC>TARIFA_ABERTURA_CONTA_CONSIGNADA</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas
                .TARIFA_ABERTURA_CONTA_CONSIGNADA
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa de Recimento de TED</Text.LabelC>
        <Text.LabelC>TARIFA_RECEBIMENTO_TED</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas.TARIFA_RECEBIMENTO_TED
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa de Recimento de TEV</Text.LabelC>
        <Text.LabelC>TARIFA_RECEBIMENTO_TEV</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas.TARIFA_RECEBIMENTO_TEV
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa de Recimento de Boleto</Text.LabelC>
        <Text.LabelC>TARIFA_RECEBIMENTO_BOLETO</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas.TARIFA_RECEBIMENTO_BOLETO
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa de Recimento de domicilio bancário</Text.LabelC>
        <Text.LabelC>TARIFA_RECEBIMENTO_DOMICILIO</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas.TARIFA_RECEBIMENTO_DOMICILIO
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa de boleto liquidado</Text.LabelC>
        <Text.LabelC>TARIFA_PIX</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas.TARIFA_BOLETO
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE BOLETO ITAÚ</Text.LabelC>
        <Text.LabelC>Recebimento de boleto</Text.LabelC>
        <Text.LabelC>BOLETO_CREDITO</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_boleto_terceiros.BOLETO_CREDITO
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE BOLETOS CONTA FIDÚCIA</Text.LabelC>
        <Text.LabelC>Recebimento de boleto</Text.LabelC>
        <Text.LabelC>BOLETO_CREDITO</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_boleto_fiducia.BOLETO_CREDITO
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE BOLETOS CONTA TERCEIROS</Text.LabelC>
        <Text.LabelC>Boletos liquidados para terceiros</Text.LabelC>
        <Text.LabelC>BOLETO_CREDITO</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_boleto_terceiros.BOLETO_CREDITO
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO BOLETO</Text.LabelC>
        <Text.LabelC>Recebimeneto de boleto</Text.LabelC>
        <Text.LabelC>BOLETO_CREDITO</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_boleto.BOLETO_CREDITO
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO BOLETO</Text.LabelC>
        <Text.LabelC>Recebimeneto de boleto</Text.LabelC>
        <Text.LabelC>BOLETO</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_boleto.Boleto
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>PAGAMENTO DE BOLETOS</Text.LabelC>
        <Text.LabelC>Pagamento de boleto</Text.LabelC>
        <Text.LabelC>Boleto</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.pagamento_boleto.Boleto
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE RECARGAS</Text.LabelC>
        <Text.LabelC>Recarga</Text.LabelC>
        <Text.LabelC>Recarga</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_recarga.Recarga
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>PAGAMENTO DE RECARGAS</Text.LabelC>
        <Text.LabelC>Recarga</Text.LabelC>
        <Text.LabelC>Recarga</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.pagamento_recarga.Recarga
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>ENVIO CARTÃO</Text.LabelC>
        <Text.LabelC>Compra via cartão</Text.LabelC>
        <Text.LabelC>CARTAO_00_PURCHASE</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.envio_cartao.CARTAO_00_PURCHASE
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>ENVIO CARTÃO</Text.LabelC>
        <Text.LabelC>Saque via cartão</Text.LabelC>
        <Text.LabelC>CARTAO_01_CASH_WITHDRAW</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.envio_cartao.CARTAO_01_CASH_WITHDRAW
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO CARTÃO</Text.LabelC>
        <Text.LabelC>Compra via cartão</Text.LabelC>
        <Text.LabelC>CARTAO_00_PURCHASE</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_cartao.CARTAO_00_PURCHASE
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>

      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO CARTÃO</Text.LabelC>
        <Text.LabelC>Saque via cartão</Text.LabelC>
        <Text.LabelC>CARTAO_01_CASH_WITHDRAW</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_cartao.CARTAO_01_CASH_WITHDRAW
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>

      <Text.Title style={{ marginBottom: '45px' }}>
        Relatório de Fechamento de{' '}
        {moment(accountingAppContext.dateSearch.start).format('DD/MM/YY')} até{' '}
        {moment(accountingAppContext.dateSearch.end).format('DD/MM/YY')}
      </Text.Title>
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TRANSFERÊNCIAS</Text.LabelC>
        <Text.LabelC>Recebimento de TED</Text.LabelC>
        <Text.LabelC>STR0008R2</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_transferencia_externa.STR0008R2
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TRANSFERÊNCIAS</Text.LabelC>
        <Text.LabelC>Estorno de TED</Text.LabelC>
        <Text.LabelC>STR0010R2</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_transferencia_externa.STR0010R2
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TRANSFERÊNCIAS</Text.LabelC>
        <Text.LabelC>Recebimento de IF para IF</Text.LabelC>
        <Text.LabelC>STR0006R2</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_transferencia_externa.STR0006R2
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TRANSFERÊNCIAS</Text.LabelC>
        <Text.LabelC>Recebimento de TED</Text.LabelC>
        <Text.LabelC>STR0007R2</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_transferencia_externa.STR0007R2
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TRANSFERÊNCIAS</Text.LabelC>
        <Text.LabelC>Pix</Text.LabelC>
        <Text.LabelC>Pix</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_transferencia_externa.Pix
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TRANSFERÊNCIAS</Text.LabelC>
        <Text.LabelC>Pix devolução</Text.LabelC>
        <Text.LabelC>Pix_devolucao</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_transferencia_externa
                .Pix_Devolucao
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TRANSFERÊNCIAS</Text.LabelC>
        <Text.LabelC>Recebimento de transferência de outra IF</Text.LabelC>
        <Text.LabelC>STR0004R2 (FIDÚCIA INVEST)</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_transferencia_externa
                .STR0004R2_INVEST
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TRANSFERÊNCIAS</Text.LabelC>
        <Text.LabelC>Recebimento de transferência de outra IF</Text.LabelC>
        <Text.LabelC>STR0004R2_FGTS</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_transferencia_externa
                .STR0004R2_FGTS
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>ENVIO DE TRANSFERÊNCIA EXTERNAS</Text.LabelC>
        <Text.LabelC>Pix</Text.LabelC>
        <Text.LabelC>Pix</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.envio_transferencia_externa.Pix
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>ENVIO DE TRANSFERÊNCIA EXTERNAS</Text.LabelC>
        <Text.LabelC>Pix Devolução</Text.LabelC>
        <Text.LabelC>Pix_Devolucao</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.envio_transferencia_externa.Pix_Devolucao
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE DOMICÍLIO BANCÁRIO</Text.LabelC>
        <Text.LabelC>Fluxo de Crédito - CIP</Text.LabelC>
        <Text.LabelC>ASLC022</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_domicilio_bancario.ASLC022
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE DOMICÍLIO BANCÁRIO</Text.LabelC>
        <Text.LabelC>Fluxo de Crédito - CIP</Text.LabelC>
        <Text.LabelC>ASLC022</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_domicilio_bancario.ASLC022
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE DOMICÍLIO BANCÁRIO</Text.LabelC>
        <Text.LabelC>Fluxo de Débito - CIP</Text.LabelC>
        <Text.LabelC>ASLC032</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_domicilio_bancario.ASLC032
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE DOMICÍLIO BANCÁRIO</Text.LabelC>
        <Text.LabelC>Fluxo de Antecipação - CIP</Text.LabelC>
        <Text.LabelC>ASLC024</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_domicilio_bancario.ASLC024
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>ENVIO DE TRANSFERÊNCIAS INTERNAS</Text.LabelC>
        <Text.LabelC>TEV Interna</Text.LabelC>
        <Text.LabelC>STR0008</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.envio_transferencia_interna.STR0008
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>
          ENVIO DE TRANSFERÊNCIAS INTERNAS PARA CONTAS DE TERCEIROS
        </Text.LabelC>
        <Text.LabelC>TEV Interna</Text.LabelC>
        <Text.LabelC>STR0008</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.envio_transferencia_interna_conta_terceiros
                .STR0008
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>
          ENVIO DE TRANSFERÊNCIAS INTERNAS PARA CONTAS FIDÚCIA
        </Text.LabelC>
        <Text.LabelC>TEV Interna</Text.LabelC>
        <Text.LabelC>STR0008</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext
                .recebimento_transferencia_interna_conta_fiducia.STR0008
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TARIFA</Text.LabelC>
        <Text.LabelC>Tarifa de Pix</Text.LabelC>
        <Text.LabelC>TARIFA_PIX</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_tarifas.TARIFA_PIX
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TARIFA</Text.LabelC>
        <Text.LabelC>Tarifa de boleto liquidado</Text.LabelC>
        <Text.LabelC>TARIFA_BOLETO</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_tarifas.TARIFA_BOLETO
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TARIFA</Text.LabelC>
        <Text.LabelC>Tarifa Genérica</Text.LabelC>
        <Text.LabelC>TARIFA</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_tarifas.TARIFA
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TARIFA</Text.LabelC>
        <Text.LabelC>Tarifa de boleto vencido</Text.LabelC>
        <Text.LabelC>TARIFA_BOLETO_VENCIDO</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_tarifas.TARIFA_BOLETO_VENCIDO
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TARIFA</Text.LabelC>
        <Text.LabelC>Tarifa de mensalidade</Text.LabelC>
        <Text.LabelC>TARIFA_MENSAL</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_tarifas.TARIFA_MENSAL
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TARIFA</Text.LabelC>
        <Text.LabelC>Tarifa de alteração de boleto</Text.LabelC>
        <Text.LabelC>TARIFA_ALTERACAO_BOLETO</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_tarifas.TARIFA_ALTERACAO_BOLETO
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TARIFA</Text.LabelC>
        <Text.LabelC>Tarifa de boleto baixado</Text.LabelC>
        <Text.LabelC>TARIFA_BAIXADO</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_tarifas.TARIFA_BAIXADO
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TARIFA</Text.LabelC>
        <Text.LabelC>Tarifa de abertura de conta PJ</Text.LabelC>
        <Text.LabelC>TARIFA_ABERTURA_CONTA_PJ</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_tarifas.TARIFA_ABERTURA_CONTA_PJ
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TARIFA</Text.LabelC>
        <Text.LabelC>Tarifa de abertura de conta PF</Text.LabelC>
        <Text.LabelC>TARIFA_ABERTURA_CONTA_PF</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_tarifas.TARIFA_ABERTURA_CONTA_PF
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TARIFA</Text.LabelC>
        <Text.LabelC>Tarifa de abertura de conta escrow</Text.LabelC>
        <Text.LabelC>TARIFA_ABERTURA_CONTA_ESCROW</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_tarifas
                .TARIFA_ABERTURA_CONTA_ESCROW
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />

      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TARIFA</Text.LabelC>
        <Text.LabelC>Tarifa de abertura de conta Consignada</Text.LabelC>
        <Text.LabelC>TARIFA_ABERTURA_CONTA_CONSIGNADA</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_tarifas
                .TARIFA_ABERTURA_CONTA_CONSIGNADA
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa de saque no Cartão</Text.LabelC>
        <Text.LabelC>TARIFA_CARTAO_SAQUE</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_tarifas.TARIFA_CARTAO_SAQUE
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa de solicitação de Cartão</Text.LabelC>
        <Text.LabelC>TARIFA_CARTAO_SOLICITACAO</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_tarifas.TARIFA_CARTAO_SOLICITACAO
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa gerar QRCode</Text.LabelC>
        <Text.LabelC>TARIFA_PIX_GERAR_QRCODE</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_tarifas.TARIFA_PIX_GERAR_QRCODE
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />

      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa de TED</Text.LabelC>
        <Text.LabelC>TAXA_TED</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas.TAXA_TED
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Recebimento de transferência para outra IF</Text.LabelC>
        <Text.LabelC>STR0004</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas.STR0004
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa de Pix</Text.LabelC>
        <Text.LabelC>TARIFA_PIX</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas.TARIFA_PIX
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa genérica</Text.LabelC>
        <Text.LabelC>TARIFA</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas.TARIFA
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa de boleto vencido</Text.LabelC>
        <Text.LabelC>TARIFA_BOLETO_VENCIDO</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas.TARIFA_BOLETO_VENCIDO
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa de mensalidade</Text.LabelC>
        <Text.LabelC>TARIFA_MENSAL</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas.TARIFA_MENSAL
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa de alteração de boleto</Text.LabelC>
        <Text.LabelC>TARIFA_ALTERACAO_BOLETO</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas.TARIFA_ALTERACAO_BOLETO
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa de boleto baixado</Text.LabelC>
        <Text.LabelC>TARIFA_BAIXADO</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas.TARIFA_BAIXADO
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa de abertura de conta PF</Text.LabelC>
        <Text.LabelC>TARIFA_ABERTURA_CONTA_PF</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas.TARIFA_ABERTURA_CONTA_PF
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa de abertura de conta PJ</Text.LabelC>
        <Text.LabelC>TARIFA_ABERTURA_CONTA_PJ</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas.TARIFA_ABERTURA_CONTA_PJ
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa de abertura de conta escrow</Text.LabelC>
        <Text.LabelC>TARIFA_ABERTURA_CONTA_ESCROW</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas.TARIFA_ABERTURA_CONTA_ESCROW
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa de abertura de conta consignada</Text.LabelC>
        <Text.LabelC>TARIFA_ABERTURA_CONTA_CONSIGNADA</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas
                .TARIFA_ABERTURA_CONTA_CONSIGNADA
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa de boleto liquidado</Text.LabelC>
        <Text.LabelC>TARIFA_PIX</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas.TARIFA_BOLETO
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa de recebimento Pix</Text.LabelC>
        <Text.LabelC>TARIFA_RECEBIMENTO_PIX</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas.TARIFA_RECEBIMENTO_PIX
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa de recebimento Pix Devolução</Text.LabelC>
        <Text.LabelC>TARIFA_RECEBIMENTO_PIX_DEVOLUCAO</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas
                .TARIFA_RECEBIMENTO_PIX_DEVOLUCAO
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa de venda Cripto</Text.LabelC>
        <Text.LabelC>TARIFA_CRIPTO_VENDA</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas.TARIFA_CRIPTO_VENDA
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa de saque no Cartão</Text.LabelC>
        <Text.LabelC>TARIFA_CARTAO_SAQUE</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas.TARIFA_CARTAO_SAQUE
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa de solicitação de Cartão</Text.LabelC>
        <Text.LabelC>TARIFA_CARTAO_SOLICITACAO</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas.TARIFA_CARTAO_SOLICITACAO
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>REPASSE DE TARIFAS</Text.LabelC>
        <Text.LabelC>Tarifa gerar QRCode</Text.LabelC>
        <Text.LabelC>TARIFA_PIX_GERAR_QRCODE</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.repasse_tarifas.TARIFA_PIX_GERAR_QRCODE
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE BOLETO ITAÚ</Text.LabelC>
        <Text.LabelC>Recebimento de boleto</Text.LabelC>
        <Text.LabelC>BOLETO_CREDITO</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_boleto_terceiros.BOLETO_CREDITO
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE BOLETOS CONTA FIDÚCIA</Text.LabelC>
        <Text.LabelC>Recebimento de boleto</Text.LabelC>
        <Text.LabelC>BOLETO_CREDITO</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_boleto_fiducia.BOLETO_CREDITO
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE BOLETOS CONTA TERCEIROS</Text.LabelC>
        <Text.LabelC>Boletos liquidados para terceiros</Text.LabelC>
        <Text.LabelC>BOLETO_CREDITO</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_boleto_terceiros.BOLETO_CREDITO
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO BOLETO</Text.LabelC>
        <Text.LabelC>Recebimeneto de boleto</Text.LabelC>
        <Text.LabelC>BOLETO_CREDITO</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_boleto.BOLETO_CREDITO
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO BOLETO</Text.LabelC>
        <Text.LabelC>Recebimeneto de boleto</Text.LabelC>
        <Text.LabelC>BOLETO</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_boleto.Boleto
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>PAGAMENTO DE BOLETOS</Text.LabelC>
        <Text.LabelC>Pagamento de boleto</Text.LabelC>
        <Text.LabelC>Boleto</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.pagamento_boleto.Boleto
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>RECEBIMENTO DE RECARGAS</Text.LabelC>
        <Text.LabelC>Recarga</Text.LabelC>
        <Text.LabelC>Recarga</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.recebimento_recarga.Recarga
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
      <AccountingDivisorDarken />
      <Wrapper.Default
        isActive
        heigth="70px"
        flexDirection="row"
        justifyContent="space-between"
        alignItens="center"
        width="100%">
        <Text.LabelC>PAGAMENTO DE RECARGAS</Text.LabelC>
        <Text.LabelC>Recarga</Text.LabelC>
        <Text.LabelC>Recarga</Text.LabelC>
        <Text.LabelC>
          {convertToReal(
            convertToRealWithChecked(
              accountingAppContext.pagamento_recarga.Recarga
            )
          )}
        </Text.LabelC>
      </Wrapper.Default>
    </Wrapper.Default>
  );
}

export default UnifiedReportOfFiduciaClosed;
